Mmg.addShortcode(

  /**
   *
   * @param {string} shortcodeName The name of the shortcode
   * @param {string} selector The selector used to locate this shortcode in the DOM
   * @param {callable} callback The callback function applied to every element matching the selector
   */
  'passport',
  '.sc-passport',

  /**
   * @param {Element} el The shortcode's DOM element
   * @param {object} model The data model passed to the shortcode instance in data-json attribute
   * @param {jQuery} $ The callback function applied to every element matching the selector
   * @param {string} selector The shortcode selector that was passed to addShortcode
   * @param {string} className The name of the shortcode class
   */
  (el, model, $, selector, className) => {

  // Widget Declarations
  const $this = $(el);
  const $items = $(`${selector}__item`);
  const $targetImage = $(`${selector}__image`);

  /**
   * Initialize the widget
   */
  (function init(){
    addEvents();
  })();


  function addEvents() {
    $items.on('click', changeImage);
  }

  /**
   * Change image and animate
   */
  function changeImage() {
    const $element = $(this);
    const newImageId = $element.index() + 1;
    $items.removeClass(`sc-passport__item-active`);
    $element.addClass(`sc-passport__item-active`);
    $targetImage
      .fadeOut(250, function () {
        $targetImage.attr('data-active', newImageId);
      })
      .fadeIn(250);
    }
});
